export class AuditStatusOrder {
  public StatusId: number;
  public WorkflowOrder: number;
}